module.exports = __webpack_public_path__ + "static/media/thum1.b7783f0f.jpg";